(() => {
  let dialog, guideImage, opener;
  let priorOverflow;
  function createDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'measure-guide-dialog';
    dialog.setAttribute('aria-label', 'Complete measuring guide');
    const header = document.createElement('div');
    header.className = 'measure-guide-dialog__header';
    const title = document.createElement('h2');
    title.textContent = 'How to measure';
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = '×';
    close.setAttribute('aria-label', 'Close measuring guide');
    header.append(title, close);
    const hint = document.createElement('p');
    hint.className = 'measure-guide-dialog__hint';
    hint.textContent = 'Scroll across the image to read every measurement.';
    const viewport = document.createElement('div');
    viewport.className = 'measure-guide-dialog__image';
    viewport.tabIndex = 0;
    viewport.setAttribute('role', 'region');
    viewport.setAttribute('aria-label', 'Measuring model and instructions. Scroll to read.');
    guideImage = document.createElement('img');
    guideImage.width = 1100;
    guideImage.height = 800;
    guideImage.alt = 'Original measuring model and instructions, labelled A to I: bust, waist, hips, hollow to floor, height, armhole, shoulder to shoulder, arm length and armpit.';
    viewport.append(guideImage);
    dialog.append(header, hint, viewport);
    document.body.append(dialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = priorOverflow;
      if (opener?.isConnected) opener.focus({preventScroll:true});
    });
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-measure-guide-open]');
    if (!trigger) return;
    const source = trigger.dataset.measureGuideSrc;
    if (!source || typeof HTMLDialogElement === 'undefined') return;
    event.preventDefault();
    if (!dialog) createDialog();
    if (dialog.open) return;
    opener = trigger;
    priorOverflow = document.body.style.overflow;
    guideImage.src = source;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dialog.querySelector('.measure-guide-dialog__image').scrollTo(0, 0);
  });
})();
